import { render, staticRenderFns } from "./comprehensive-analysis.vue?vue&type=template&id=21a61294&scoped=true&"
import script from "./comprehensive-analysis.vue?vue&type=script&lang=js&"
export * from "./comprehensive-analysis.vue?vue&type=script&lang=js&"
import style0 from "./comprehensive-analysis.vue?vue&type=style&index=0&id=21a61294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a61294",
  null
  
)

export default component.exports